import {
  ConversationEventType,
  ConversationMessage,
} from '@stripe-internal/conversations-client';

export const ANIMATION_DURATION_WITH_BUFFER_MS = 450;

type EmitConversationEvent = (event: ConversationEventType) => void;

export async function waitForAnimation(): Promise<void> {
  await new Promise((resolve) => {
    setTimeout(resolve, ANIMATION_DURATION_WITH_BUFFER_MS);
  });
}

function emitMessageAdded({
  conversationId,
  emitConversationEvent,
  message,
}: {
  conversationId: string;
  emitConversationEvent: EmitConversationEvent;
  message: ConversationMessage;
}): void {
  emitConversationEvent({
    name: 'conversation-message-added',
    conversationId,
    participantId: message.participant.id,
    messageId: message.id,
    nonce: message.nonce,
    message,
  });
}

export async function emitMessagesWithAnimation({
  conversationId,
  emitConversationEvent,
  messages,
  waitForCompletion = true,
}: {
  conversationId: string;
  emitConversationEvent: EmitConversationEvent;
  messages: ConversationMessage[];
  waitForCompletion?: boolean;
}): Promise<void> {
  const emitPromises = messages.map((message, index) => {
    if (index === 0) {
      emitMessageAdded({conversationId, emitConversationEvent, message});
      return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
      setTimeout(() => {
        emitMessageAdded({conversationId, emitConversationEvent, message});
        resolve();
      }, ANIMATION_DURATION_WITH_BUFFER_MS * index);
    });
  });

  if (waitForCompletion) {
    await Promise.all(emitPromises);
  }
}
